
/* styles */
require("!!../../node_modules/.2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/.11.3.4@vue-loader/lib/style-compiler/index?{\"id\":\"data-v-905e65d4\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/.11.3.4@vue-loader/lib/selector?type=styles&index=0!./Buttons.vue")

var Component = require("!../../node_modules/.11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.11.3.4@vue-loader/lib/selector?type=script&index=0!./Buttons.vue"),
  /* template */
  require("!!../../node_modules/.11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-905e65d4\"}!../../node_modules/.11.3.4@vue-loader/lib/selector?type=template&index=0!./Buttons.vue"),
  /* scopeId */
  "data-v-905e65d4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons.vue
// module id = 29
// module chunks = 13